import { useState } from 'react';
import './App.css';
import LeftPanel from './components/LeftPanel/LeftPanel';
import RightPanel from './components/RightPanelPages/Index';


function App() {

  const [activeTab, setActiveTab] = useState('home');
  return (
    <div className="AppContainer">
      <LeftPanel activeTab={activeTab} setActiveTab={setActiveTab} />
      <RightPanel activeTab={activeTab} setActiveTab={setActiveTab} />
    </div>
  );
}

export default App;
